import 
    React
    , {
        useEffect
    } from 'react';

import SenseiCreateAccount from "../Home/SenseiCreateAccount";
import OwnIncomeProducing from "./OwnIncomeProducing1584x396";
import OwnIncomeProducing2 from "./OwnIncomeProducing1128x191";

/*
Dark background image = "linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)" />
Light background image = "linear-gradient(180deg, #000000 0%, #2C466B 100%)" />
*/

const Banners = () => {
    console.log('Banners()');

    useEffect(() => {
        //document.getElementsByTagName('body')[0].classList.add('');
        //document.getElementsByTagName('body')[0].classList.remove('search');
        document.getElementsByTagName('body')[0].className = '';
    }, null);

    return (
        <main>

            {/*
            <SenseiCreateAccount />
            */}

            <OwnIncomeProducing />

            <OwnIncomeProducing2 />

        </main>
    );
};

export default Banners;
